<div class="action-center-container" [class.action-center--no-access]="!totalRisks">
  <!-- Panel Header -->
  <div class="action-center-header" (click)="toggleCollapse()" [class.cursor-pointer]="!!totalRisks">
    <div class="header-left">
      <h2 class="header-title">
        <span>Action Center: Manual Suggestion</span>
        <div class="d-flex align-items-center justify-content-center">
          <i
            class="fas fa-info-circle text-secondary"
            style="font-size: 16px;"
            container="body"
            placement="bottom"
            [ngbTooltip]="headerTooltip"
          ></i>
        </div>

        <span class="header-summary ml-1" *ngIf="isCollapsed">
          <span class="summary-badge">{{ totalRisks }} SKU(s) need attention</span>
        </span>
      </h2>
      
      <p class="header-subtitle" *ngIf="!isCollapsed">
        Manual intervention required for SKUs where Auto Mode is disabled.
      </p>
    </div>
    
    <div class="header-right">
      <i class="fas fa-chevron-down toggle-icon" [class.rotated]="!isCollapsed"></i>
    </div>
  </div>

  <!-- Panel Body (Grid) -->
  <div [ngbCollapse]="isCollapsed">
    <div class="action-center-body">
      <!-- Risk Grid: Always visible, but counts show skeleton during loading -->
      <div class="risk-grid">
        <ng-container *ngFor="let risk of risks; trackBy: trackByRisks">
          <!-- Standard card (active-high and active-mod with external + total rows) -->
          <div
            *ngIf="risk.id !== 'paused-well' && risk.id !== 'paused-mod'"
            class="risk-card"
            [ngClass]="['risk-card--' + risk.type]"
            [class.risk-card--selected]="risk.isSelected"
            [class.risk-card--zero]="risk.count === 0 && !isLoading"
            (click)="toggleCardSelection(risk)"
          >
            <div class="card-header-row">
              <span class="card-title">{{ risk.title }}</span>
              <div class="card-header-right">
                <span class="card-count-badge" *ngIf="!isLoading" [class.card-count-badge--zero]="risk.count === 0">{{ risk.count }}</span>
                <span class="card-skeleton card-skeleton--badge" *ngIf="isLoading"></span>
                <i class="fas fa-info-circle info-icon" container="body" placement="top auto" [ngbTooltip]="risk.tooltip"></i>
              </div>
            </div>

            <!-- System-managed row: active by system -->
            <div class="card-content-row card-content-row--scoped">
              <div class="card-scope-label">
                <i class="fas fa-robot scope-icon scope-icon--managed"></i>
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.wellStockedManaged }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">active by system</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-primary-action"
                  [disabled]="(risk.wellStockedManaged === 0 && !isLoading) || isLoading"
                  (click)="onPrimaryActionScoped($event, risk, 'managed')"
                >
                  <i [class]="risk.icon"></i>
                  Pause ({{ risk.wellStockedManaged }})
                </button>
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.wellStockedManaged === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'managed')"
                >
                  View
                </button>
              </div>
            </div>

            <!-- External (no system management) row — View only, no Pause button -->
            <div class="card-content-row card-content-row--scoped">
              <div class="card-scope-label">
                <i class="fas fa-user scope-icon scope-icon--external"></i>
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.wellStockedExternal }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">active by external</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.wellStockedExternal === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'external')"
                >
                  View
                </button>
              </div>
            </div>

            <!-- Total row: View All -->
            <div class="card-content-row card-content-row--scoped card-content-row--all">
              <div class="card-scope-label">
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.count }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">active total</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.count === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'all')"
                >
                  View All
                </button>
              </div>
            </div>
          </div>

          <!-- Paused-Moderate Risk card: 3 scoped rows -->
          <div
            *ngIf="risk.id === 'paused-mod'"
            class="risk-card risk-card--moderate-risk"
            [ngClass]="['risk-card--' + risk.type]"
            [class.risk-card--selected]="risk.isSelected"
            [class.risk-card--zero]="risk.count === 0 && !isLoading"
            container="body"
            placement="top auto"
            (click)="toggleCardSelection(risk)"
          >
            <div class="card-header-row">
              <span class="card-title">{{ risk.title }}</span>
              <div class="card-header-right">
                <span class="card-count-badge" *ngIf="!isLoading" [class.card-count-badge--zero]="risk.count === 0">{{ risk.count }}</span>
                <span class="card-skeleton card-skeleton--badge" *ngIf="isLoading"></span>
                <i class="fas fa-info-circle info-icon" container="body" placement="top auto" [ngbTooltip]="risk.tooltip"></i>
              </div>
            </div>

            <!-- System-managed row -->
            <div class="card-content-row card-content-row--scoped">
              <div class="card-scope-label">
                <i class="fas fa-robot scope-icon scope-icon--managed"></i>
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.wellStockedManaged }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">paused by system</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-primary-action"
                  [disabled]="(risk.wellStockedManaged === 0 && !isLoading) || isLoading"
                  (click)="onPrimaryActionScoped($event, risk, 'managed')"
                >
                  <i [class]="risk.icon"></i>
                  Enable ({{ risk.wellStockedManaged }})
                </button>
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.wellStockedManaged === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'managed')"
                >
                  View
                </button>
              </div>
            </div>

            <!-- Externally paused row — View only, no Enable button -->
            <div class="card-content-row card-content-row--scoped">
              <div class="card-scope-label">
                <i class="fas fa-user scope-icon scope-icon--external"></i>
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.wellStockedExternal }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">paused by external</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.wellStockedExternal === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'external')"
                >
                  View
                </button>
              </div>
            </div>

            <!-- Enable All / View All row — View only, no Enable button -->
            <div class="card-content-row card-content-row--scoped card-content-row--all">
              <div class="card-scope-label">
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.count }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">paused total</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.count === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'all')"
                >
                  View All
                </button>
              </div>
            </div>
          </div>

          <!-- Paused-Well Stocked card: 3 scoped rows -->
          <div
            *ngIf="risk.id === 'paused-well'"
            class="risk-card risk-card--well-stocked"
            [ngClass]="['risk-card--' + risk.type]"
            [class.risk-card--selected]="risk.isSelected"
            [class.risk-card--zero]="risk.count === 0 && !isLoading"
            (click)="toggleCardSelection(risk)"
          >
            <div class="card-header-row">
              <span class="card-title">{{ risk.title }}</span>
              <div class="card-header-right">
                <span class="card-count-badge" *ngIf="!isLoading" [class.card-count-badge--zero]="risk.count === 0">{{ risk.count }}</span>
                <span class="card-skeleton card-skeleton--badge" *ngIf="isLoading"></span>
                <i class="fas fa-info-circle info-icon" container="body" placement="top auto" [ngbTooltip]="risk.tooltip"></i>
              </div>
            </div>

            <!-- System-managed row -->
            <div class="card-content-row card-content-row--scoped">
              <div class="card-scope-label">
                <i class="fas fa-robot scope-icon scope-icon--managed"></i>
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.wellStockedManaged }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">paused by system</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-primary-action"
                  [disabled]="(risk.wellStockedManaged === 0 && !isLoading) || isLoading"
                  (click)="onPrimaryActionScoped($event, risk, 'managed')"
                >
                  <i [class]="risk.icon"></i>
                  Enable ({{ risk.wellStockedManaged }})
                </button>
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.wellStockedManaged === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'managed')"
                >
                  View
                </button>
              </div>
            </div>

            <!-- Externally paused row — View only, no Enable button -->
            <div class="card-content-row card-content-row--scoped">
              <div class="card-scope-label">
                <i class="fas fa-user scope-icon scope-icon--external"></i>
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.wellStockedExternal }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">paused by external</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.wellStockedExternal === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'external')"
                >
                  View
                </button>
              </div>
            </div>

            <!-- Enable All / View All row — View only, no Enable button -->
            <div class="card-content-row card-content-row--scoped card-content-row--all">
              <div class="card-scope-label">
                <span class="card-count-inline" *ngIf="!isLoading">{{ risk.count }}</span>
                <span class="card-skeleton card-skeleton--inline" *ngIf="isLoading"></span>
                <span class="scope-text">paused total</span>
              </div>
              <div class="card-actions">
                <button
                  class="btn-action btn-view-action"
                  [disabled]="(risk.count === 0 && !isLoading) || isLoading"
                  (click)="onViewActionScoped($event, risk, 'all')"
                >
                  View All
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
